// app layout
const LEFT_PANEL_BG_BLUR_Z_INDEX = 11;
const LEFT_PANEL_Z_INDEX = LEFT_PANEL_BG_BLUR_Z_INDEX + 1;

// circle
const CIRCLE_LEADERBOARD_BUTTON_Z_INDEX = LEFT_PANEL_BG_BLUR_Z_INDEX - 1;
const CIRCLE_HEADER_Z_INDEX = LEFT_PANEL_BG_BLUR_Z_INDEX - 1;

const ZINDEX = {
  MATH_CANVAS_POLYPAD: 5,
  BANNER_HEADER: 13,
  CLASS_STATUS: 13,
  SNACKBAR: 15,
  HEADER: 17,
  REVIEW_HEADER: 15,
  NAVIGATOR_ARROW_PANEL: 15,
  CALL_WINDOW: 17,
  QUESTION_ACTION_BAR: 17,
  CHAT: 18,
  WHITEBOARD: 19,
  MODAL: 20,
  AV_PLAYER: 18,
  INTERNET_CONNECTIVITY: 19,
  EVENT_TRIGGERED_MODAL: 20,
  MASTERY_MODAL: 99,
  CHAT_WINDOW: 21,
  STUDENT_FEEDBACK_MODAL: 100,
  SP_SHEET_LOAD_ANIME: 18,
  EXTEND_CLASS_ANIMATION_1: 24,
  EXTEND_CLASS_ANIMATION_2: 25,
  EXTEND_CLASS_ANIMATION_3: 26,
  CUSTOM_PAGE_LOADER: 18,
  SAT_HEADER: 2,
  SHEET_PANEL: 15,
  LEFT_PANEL_BG_BLUR_Z_INDEX: LEFT_PANEL_BG_BLUR_Z_INDEX,
  LEFT_PANEL_Z_INDEX: LEFT_PANEL_Z_INDEX,
  CIRCLE_LEADERBOARD_BUTTON_Z_INDEX: CIRCLE_LEADERBOARD_BUTTON_Z_INDEX,
  CIRCLE_HEADER_Z_INDEX: CIRCLE_HEADER_Z_INDEX,
};

export default ZINDEX;
